import { Link } from "react-router-dom";

export default function PricingSection() {
  const plans = [
    {
      title: "Premium",
      description: "This plan includes 25 jobs. Each project will be displayed as normal for 30 days.",
      highlighted: true,
    },
    {
      title: "Standard",
      description: "This plan includes 7 tasks. Each project will be displayed as featured for 14 days.",
      highlighted: false,
      badge: "Most Popular",
    },
    {
      title: "Free",
      description: "You have 2 time to submit a free project. Each project will be displayed as normal for 5 days.",
      highlighted: false,
    },
  ];

  const handleSignUpClick = () => {
    window.dispatchEvent(new CustomEvent("open-auth-modal", { detail: { mode: "signup" } }));
  };

  return (
    <section className="py-12 md:py-16 bg-[#0d1117]">
      <div className="w-full px-4 md:px-8 max-w-5xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-100">Choose Your Plan</h2>
          <p className="text-sm text-gray-400 mt-2">Pick the tier that fits your needs and start posting projects today</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {plans.map((plan) => (
            <div
              key={plan.title}
              className={`rounded overflow-hidden text-center transition-all duration-300 hover:scale-[1.02] ${
                plan.highlighted
                  ? "border-2 border-[#5bc0de] p-8 bg-[#5bc0de]/5 hover:border-[#46b8da] hover:bg-[#5bc0de]/10"
                  : "border border-gray-700 p-6 hover:border-[#5bc0de]/60"
              }`}
            >
              {plan.badge && (
                <span className="inline-block bg-[#5bc0de] text-white text-xs font-semibold px-3 py-1 rounded-full mb-3">
                  {plan.badge}
                </span>
              )}
              <h3 className={`text-lg font-semibold mb-3 ${
                plan.highlighted ? "text-[#5bc0de]" : "text-gray-200"
              }`}>
                {plan.title}
              </h3>
              <p className="text-sm text-gray-400 mb-6 leading-relaxed min-h-[60px]">
                {plan.description}
              </p>
              <button
                onClick={handleSignUpClick}
                className="inline-block bg-[#5bc0de] hover:bg-[#46b8da] text-white text-sm font-semibold px-6 py-2 rounded transition-all whitespace-nowrap cursor-pointer"
              >
                Sign Up
              </button>
            </div>
          ))}
        </div>

        {/* Private Contact CTA */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-4 py-6 border-t border-b border-gray-700">
          <h3 className="text-lg md:text-xl font-semibold text-gray-200 text-center sm:text-left">
            Need A Private Request? Contact Us Directly&gt;&gt;&gt;
          </h3>
          <Link
            to="/contact"
            className="inline-block bg-[#5bc0de] hover:bg-[#46b8da] text-white text-xs font-semibold px-5 py-2 rounded transition-all whitespace-nowrap"
          >
            PRIVATE CONTACT
          </Link>
        </div>
      </div>
    </section>
  );
}